import React, { Dispatch, SetStateAction, useState } from 'react';

import { CreateUpdateProfileCategoryDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useNotifications } from '../../../common/hooks/useNotifications';
import LastEditorInfo from '../../../app/components/LastEditorInfo';
import { usePokCore } from '../../../common/hooks/usePokCore';
import Button from '../../../common/components/Button/Button';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface ProfileCategoryEditorProps {
  id?: string;
  profileCategory: CreateUpdateProfileCategoryDto;
  handleClose?: () => void;
  closeAfterCompleted?: boolean;
  onCompleted: (
    profileCategory: CreateUpdateProfileCategoryDto,
    id?: string,
  ) => Promise<{
    saved: boolean;
    errors: string[];
  }>;
  setSaveErrors: Dispatch<SetStateAction<string[]>>;
  setShowSaveErrors: Dispatch<SetStateAction<boolean>>;
}

export const ProfileCategoryEditorControls: React.FC<
  ProfileCategoryEditorProps
> = props => {
  const [isLoading, setIsLoading] = useState(false);

  const pok = usePokCore();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('administrationLng');

  const createProfileCategory = async () => {
    setIsLoading(true);
    props.setShowSaveErrors(false);
    props
      .onCompleted(props.profileCategory, props.id)
      .then(saveStatus => {
        if (!saveStatus.saved) {
          props.setSaveErrors(saveStatus.errors);
          props.setShowSaveErrors(true);
          return;
        }
        notifications.saveCompleted();
        if (props.closeAfterCompleted === true) {
          props.handleClose?.();
        }
      })
      .catch(async errorResponse => {
        notifications.caughtError(errorResponse);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      {props.id && (
        <LastEditorInfo
          id={props.id}
          method={pok.profileCategories.getLastEditor}
        />
      )}
      <Button
        className="ms-2 mt-4"
        variant="outline-secondary"
        onClick={props.handleClose}
        disabled={isLoading}
      >
        {t(tk.button.close)}
      </Button>
      <Button
        className="ms-2 mt-4"
        variant="primary"
        onClick={createProfileCategory}
        isLoading={isLoading}
      >
        {props.id ? t(tk.button.save) : t(tk.button.add)}
      </Button>
    </>
  );
};
